import { Button, Stack, Text } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { useState } from 'react';
import { Navigate } from 'react-router';
import PageLoader from 'src/UI/loader/PageLoader';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import { useSessionData } from 'src/auth/SessionDataHook';
import { useIsAfternoon } from 'src/common/useIsAfternoonHook';
import AutoBrandDrawer from 'src/secret-menu/auto-brand/AutoBrandDrawer';

export default function AutoBrandTab() {
  const { isAfternoon } = useIsAfternoon();
  const { session } = useSessionData();
  const { currentUser } = useCurrentUser();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const authLoading = !session || !currentUser;

  if (authLoading) {
    return <PageLoader />;
  }

  if (!isAfternoon) {
    return <Navigate to="/secret-menu/companies" replace />;
  }

  return (
    <Stack gap="lg" maw={640} p="md" bg="white">
      <Stack gap={4}>
        <Text size="displayXs" fw={FONT_WEIGHTS.semibold}>
          Auto Brand
        </Text>
        <Text size="textMd" c="gray.6">
          Brand a tenant from a sample document with AI-assisted extraction.
        </Text>
      </Stack>
      <Button
        leftSection={<IconSparkles size={16} />}
        onClick={() => setDrawerOpen(true)}
        w="fit-content"
      >
        Start branding a tenant
      </Button>
      <AutoBrandDrawer
        opened={drawerOpen}
        close={() => setDrawerOpen(false)}
        initialCompany={null}
      />
    </Stack>
  );
}
